var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaLuna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_2",
    "data-name": "Capa 2",
    viewBox: "0 0 1049.08 599.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-size: 11.3px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        font-family: Montserrat-Bold, Montserrat;\n        font-weight: 700;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        font-size: 22.36px;\n      }\n\n      .cls-6 {\n        stroke: url(#Degradado_sin_nombre_6);\n        stroke-width: 6px;\n      }\n\n      .cls-6, .cls-7, .cls-8, .cls-9 {\n        fill: none;\n      }\n\n      .cls-6, .cls-8, .cls-9 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        font-size: 11.65px;\n      }\n\n      .cls-4 {\n        font-size: 11.56px;\n      }\n\n      .cls-10 {\n        fill: #eb5527;\n      }\n\n      .cls-7 {\n        stroke-linejoin: round;\n      }\n\n      .cls-7, .cls-8 {\n        stroke: #ed7850;\n      }\n\n      .cls-7, .cls-8, .cls-9 {\n        stroke-linecap: round;\n        stroke-width: 2px;\n      }\n\n      .cls-11 {\n        fill: #ed7851;\n      }\n\n      .cls-12 {\n        letter-spacing: 0em;\n      }\n\n      .cls-13 {\n        letter-spacing: 0em;\n      }\n\n      .cls-14 {\n        fill: #b73011;\n      }\n\n      .cls-15 {\n        fill: #ed7850;\n      }\n\n      .cls-9 {\n        stroke: #ed7851;\n      }\n\n      .cls-16 {\n        fill: #f7955d;\n      }\n\n      .cls-17 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-18 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-19 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-20 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-21 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-22 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-23 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-24 {\n        letter-spacing: 0em;\n      }\n\n      .cls-25 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-26 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-27 {\n        letter-spacing: 0em;\n      }\n\n      .cls-28 {\n        letter-spacing: 0em;\n      }\n\n      .cls-29 {\n        letter-spacing: 0em;\n      }\n\n      .cls-30 {\n        letter-spacing: 0em;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6",
    "data-name": "Degradado sin nombre 6",
    x1: 524.54,
    y1: 506.74,
    x2: 524.54,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#051432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#754440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#cb694b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed7850"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M464.28,346.04h34.63c2.6,0,4.72,2.12,4.72,4.72v31.72c0,2.6,2.12,4.72,4.72,4.72h32.11c2.6,0,4.72-2.12,4.72-4.72v-57.44c0-11.45-9.3-20.75-20.75-20.75h-60.14c-1.26,0-2.49.52-3.38,1.41l-15.9,16.25c-1.8,1.84-1.8,4.8,0,6.62l15.88,16.07c.89.89,2.1,1.39,3.37,1.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M586.74,386.9c0,34.48-27.95,62.44-62.44,62.44s-62.43-27.97-62.43-62.44c0-34.48,27.95-62.44,62.44-62.44,34.5,0,62.44,27.95,62.44,62.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M584.8,428.46h-34.63c-2.6,0-4.72-2.12-4.72-4.72v-31.72c0-2.6-2.12-4.72-4.72-4.72h-32.11c-2.6,0-4.72,2.12-4.72,4.72v57.46c0,11.45,9.3,20.75,20.75,20.75h60.16c1.26,0,2.49-.52,3.37-1.41l15.9-16.23c1.8-1.84,1.8-4.8,0-6.62l-15.9-16.07c-.89-.89-2.1-1.39-3.35-1.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M545.43,387.27c0,11.47-9.3,20.77-20.77,20.77-11.47,0-20.77-9.3-20.77-20.77,0-11.47,9.3-20.77,20.77-20.77,11.47,0,20.77,9.3,20.77,20.77"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 0,
    y: 538.84,
    width: 201.01,
    height: 60.86,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 848.07,
    y: 538.83,
    width: 201.01,
    height: 60.86,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(51.74 576.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ORIGEN")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(363.54 576.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ERPs")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(601.63 576.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AD"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 35.6,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    x: 52.89,
    y: 0
  }, "ANA")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(897.1 576.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 33.48,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 47.52,
    y: 0
  }, "TINO")), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "282.55 566.79 238.65 566.79 238.65 571.83 282.55 571.83 271.73 582.65 275.28 586.21 292.18 569.31 275.9 553.03 272.34 556.59 282.55 566.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "544.68 566.79 500.77 566.79 500.77 571.83 544.68 571.83 533.85 582.65 537.41 586.21 554.31 569.31 538.03 553.03 534.47 556.59 544.68 566.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "800.7 566.79 756.79 566.79 756.79 571.83 800.7 571.82 789.88 582.65 793.43 586.21 810.33 569.31 794.05 553.03 790.49 556.59 800.7 566.79"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M124.7,437.42v12.59c0,3.19-2.59,5.78-5.78,5.78h-40.01c-3.19,0-5.78-2.59-5.78-5.78v-12.59"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 98.92,
    y1: 439.1,
    x2: 98.92,
    y2: 404.43
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "84.75 418.5 98.92 404.33 113.24 418.65"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M971.16,437.42v12.59c0,3.19-2.59,5.78-5.78,5.78h-40.01c-3.19,0-5.78-2.59-5.78-5.78v-12.59"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 945.38,
    y1: 404.33,
    x2: 945.38,
    y2: 439
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "959.55 424.93 945.38 439.1 931.05 424.77"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 118.43,
    y1: 311.05,
    x2: 118.43,
    y2: 331.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 130.16,
    y1: 311.05,
    x2: 130.16,
    y2: 331.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 141.89,
    y1: 311.05,
    x2: 141.89,
    y2: 331.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 153.62,
    y1: 311.05,
    x2: 153.62,
    y2: 331.4
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 109.44,
    y1: 343.26,
    x2: 162.61,
    y2: 343.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "136.03 286.21 112.78 300.14 159.27 300.14 136.03 286.21"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 891.31,
    y1: 311.22,
    x2: 891.31,
    y2: 331.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 903.03,
    y1: 311.22,
    x2: 903.03,
    y2: 331.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 914.76,
    y1: 311.22,
    x2: 914.76,
    y2: 331.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 926.49,
    y1: 311.22,
    x2: 926.49,
    y2: 331.58
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 882.31,
    y1: 343.43,
    x2: 935.48,
    y2: 343.43
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "908.9 286.39 885.66 300.31 932.14 300.31 908.9 286.39"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 209.76,
    y1: 221.34,
    x2: 194.97,
    y2: 221.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M184.01,221.34h-4.69c-1.64,0-2.98-1.33-2.98-2.98v-30.44c0-1.64,1.33-2.98,2.98-2.98h25.42c1.63,0,2.96,1.32,2.98,2.95l.06,7.36,9.36.08c.67,0,1.3.31,1.72.82l3.99,4.88,4.96,6.18c.43.54.67,1.21.67,1.91v9.25c0,1.64-1.33,2.98-2.98,2.98h-4.81"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 207.78,
    y1: 195.25,
    x2: 207.78,
    y2: 221.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 189.52,
    cy: 221.27,
    r: 5.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 215.28,
    cy: 221.27,
    r: 5.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 599.02,
    y1: 92.43,
    x2: 584.23,
    y2: 92.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M573.27,92.43h-4.69c-1.64,0-2.98-1.33-2.98-2.98v-30.44c0-1.64,1.33-2.98,2.98-2.98h25.42c1.63,0,2.96,1.32,2.98,2.95l.06,7.36,9.36.08c.67,0,1.3.31,1.72.82l3.99,4.88,4.96,6.18c.43.54.67,1.21.67,1.91v9.25c0,1.64-1.33,2.98-2.98,2.98h-4.81"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 597.04,
    y1: 66.35,
    x2: 597.04,
    y2: 92.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 578.78,
    cy: 92.37,
    r: 5.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 604.54,
    cy: 92.37,
    r: 5.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 845.95,
    y1: 221.6,
    x2: 831.16,
    y2: 221.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M820.19,221.6h-4.69c-1.64,0-2.98-1.33-2.98-2.98v-30.44c0-1.64,1.33-2.98,2.98-2.98h25.42c1.63,0,2.96,1.32,2.98,2.95l.06,7.36,9.36.08c.67,0,1.3.31,1.72.82l3.99,4.88,4.96,6.18c.43.54.67,1.21.67,1.91v9.25c0,1.64-1.33,2.98-2.98,2.98h-4.81"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 843.97,
    y1: 195.51,
    x2: 843.97,
    y2: 221.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 825.7,
    cy: 221.53,
    r: 5.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 851.46,
    cy: 221.53,
    r: 5.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 301.41,
    cy: 107.89,
    r: 12.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M329.61,133.89c0,2.14-.89,4.06-2.33,5.43-1.35,1.28-3.17,2.07-5.18,2.07-4.14,0-7.5-3.36-7.5-7.5s3.36-7.5,7.5-7.5,7.5,3.36,7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M280.97,142.3s-.65-24.25,26.32-21.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 332.58,
    y1: 144.43,
    x2: 327.28,
    y2: 139.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M280.97,142.3s-.67-24.05,26.32-21.02"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 728.57,
    cy: 108.44,
    r: 12.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M756.77,134.44c0,2.14-.89,4.06-2.33,5.43-1.35,1.28-3.17,2.07-5.18,2.07-4.14,0-7.5-3.36-7.5-7.5s3.36-7.5,7.5-7.5,7.5,3.36,7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M708.13,142.85s-.65-24.25,26.32-21.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 759.75,
    y1: 144.98,
    x2: 754.44,
    y2: 139.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M708.13,142.85s-.67-24.05,26.32-21.02"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M443.06,71.68v-12.59c0-3.19,1.79-5.78,3.99-5.78h27.63c2.2,0,3.99,2.59,3.99,5.78v12.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "484.34 76.72 460.87 66.11 437.39 76.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M444.11,94.96s-5.17-4.79-6.73-18.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M480.37,91.5c1.5-3.09,3.19-7.88,3.98-14.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 460.87,
    y1: 45.29,
    x2: 460.87,
    y2: 52.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 460.87,
    y1: 67.92,
    x2: 460.87,
    y2: 76.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M434.32,93.92c2.57,2.84,7.02,3.78,10.51,2.21,2.8-1.26,5.01-3.93,8.06-4.31,2.68-.33,5.2,1.22,7.46,2.71,2.26,1.49,4.78,3.03,7.46,2.69,3.25-.42,5.49-3.43,8.48-4.76,3.26-1.45,9.93-.02,12.78,3.69"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1025.28,503.74h-149.7c0-193.57-157.48-351.04-351.04-351.04S173.5,310.17,173.5,503.74H23.8c0-67.57,13.25-133.15,39.38-194.93,25.22-59.64,61.32-113.18,107.28-159.14,45.96-45.96,99.51-82.06,159.14-107.28C391.39,16.25,456.98,3,524.54,3s133.15,13.25,194.93,39.38c59.64,25.22,113.18,61.32,159.14,107.28,45.96,45.96,82.06,99.51,107.28,159.14,26.13,61.78,39.38,127.37,39.38,194.93Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(53.91 478.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 7.74,
    y: 0
  }, "X"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 15.8,
    y: 0
  }, "PO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 34.17,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 42.61,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 49.41,
    y: 0
  }, "ADOR")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(904 478.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IMPO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 33.32,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 41.76,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.56,
    y: 0
  }, "ADOR")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(106.06 367.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BAN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 27.26,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.62,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(891.31 367.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BAN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 27.26,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.62,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(144.57 250.68)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TRANSPO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 59.91,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 68.35,
    y: 0
  }, "TI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 79.38,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 86.7,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 93.49,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(246.86 166.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 8.54,
    y: 0
  }, "GENTE AD"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 69.74,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    x: 78.47,
    y: 0
  }, "ANAL")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(451.07 125.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 7.58,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 16.67,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.93,
    y: 0
  }, "\xCDO INTERN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 86.23,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 94.77,
    y: 0
  }, "CIONAL")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(686.86 166.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 8.54,
    y: 0
  }, "GENTE AD"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 69.74,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    x: 78.47,
    y: 0
  }, "ANAL")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(798.52 251.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TRANSPO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 59.45,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 67.84,
    y: 0
  }, "TI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 78.78,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 86.04,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 92.78,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M551.57,46.87c-.86-.89-2.05-1.3-3.27-1.13l-1.8.25c-5.5.76-10.57,3.46-14.28,7.58l-1.54,1.71-7.8-1.92h.01s-9.17-2.26-9.17-2.26h0s-8.94-2.19-8.94-2.19c-.33-.08-.68.01-.92.25l-4.23,4.07c-.22.21-.33.5-.3.8.02.23.12.43.27.59.05.05.11.1.17.14l19.69,13.02-9.03,10.04-12.46-.98c-.28-.02-.56.08-.76.27l-3.72,3.58c-.23.22-.34.55-.29.86.03.2.13.39.26.53.08.08.17.15.28.2l11.14,5.45-.07.21c-.36,1.15-.07,2.35.76,3.21h0c.83.87,2.02,1.2,3.18.88l.21-.06,5.02,11.34c.05.11.11.2.19.29.14.14.32.24.52.28.32.06.64-.03.87-.26l3.72-3.58c.2-.2.31-.47.3-.75l-.51-12.49,10.38-8.64,12.26,20.17c.04.06.08.12.13.17.15.16.36.26.58.29.3.04.6-.06.81-.27l4.23-4.07c.24-.23.35-.58.28-.91l-1.86-9.02h0s-1.91-9.26-1.91-9.26h0s-1.62-7.86-1.62-7.86l1.76-1.47c4.27-3.55,7.15-8.52,8.12-13.98l.32-1.79c.22-1.21-.15-2.42-1.01-3.31ZM501.88,53.79l2.95-2.84,24.36,5.99-8.4,9.35-18.91-12.5ZM545.71,93.43l-2.95,2.84-11.77-19.37,9.66-8.04,5.06,24.57ZM550.63,49.83l-.32,1.79c-.89,5.01-3.53,9.56-7.44,12.81l-25.43,21.17c-.12.1-.24.19-.36.28l.52,13.05-2.38,2.29-5.04-11.65c-.3.1-.6.19-.91.27l-1.03.28c-.45.12-.92,0-1.25-.34h0c-.33-.34-.44-.81-.3-1.26l.32-1.02c.1-.34.24-.65.36-.98l-11.51-5.4,2.38-2.29,12.9,1.18c.14-.17.27-.35.42-.52l22.12-24.61c3.4-3.78,8.05-6.25,13.08-6.95l1.8-.25c.59-.08,1.16.12,1.57.54.41.43.59,1.01.48,1.59Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaLuna);
export default __webpack_public_path__ + "static/media/media-luna.3004b4ccb4ac145da1fd041e1e034856.svg";
export { ForwardRef as ReactComponent };